import {checkSlug} from '@/api/sites';
import {useEffect, useState} from 'react';
import {useQuery} from '@tanstack/react-query';

export function useSlugCheck(slug: string) {
    const [debouncedSlug, setDebouncedSlug] = useState('');

    useEffect(() => {
        if (!slug || slug.length < 2) {
            setDebouncedSlug('');
            return;
        }

        const timer = setTimeout(() => {
            setDebouncedSlug(slug);
        }, 500);

        return () => clearTimeout(timer);
    }, [slug]);

    return useQuery({
        queryKey: ['slug-check', debouncedSlug],
        queryFn: () => checkSlug(debouncedSlug),
        enabled: debouncedSlug.length >= 2,
        retry: false,
        staleTime: 10_000
    });
}
